import { LockOutlined } from "@ant-design/icons";
import {
  LoginForm,
  ProConfigProvider,
  ProFormText,
} from "@ant-design/pro-components";
import { Tabs, theme, Input, Form } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from "src/common/utils/apiRequest";
import firebase from "src/firebase/firebase";

type LoginType = "password";

export default () => {
  const { token } = theme.useToken();
  const [loginType, setLoginType] = useState<LoginType>("password");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [Authenticating, setAuthenticating] = useState(false);
  const [loginError, setLoginError] = useState("Authenticate");

  const navigate = useNavigate();

  const authorize = (password: string) => {
    setAuthenticating(true);

    localStorage.setItem("waiting", "1");
    const API_REQUEST = new apiRequest("authorize", true, true);

    return API_REQUEST.send(
      {
        username: localStorage.getItem("username"),
        password: password,
      },
      (data: {
        status: string;
        token: string;
        language: string;
        message: string;
        user: string;
        last_logined: string;
        role: string;
      }) => {
        if (data.status === "success") {
          firebase();
          localStorage.setItem("token", data.token);
          localStorage.setItem("user_lng", data.language);
          localStorage.setItem("role", data.role);
          localStorage.setItem("last_logined", data.last_logined);

          localStorage.setItem(
            "toast",
            JSON.stringify({
              type: "success",
              message: "Re-logged in as " + data.user,
              description: "Last Login: " + data.last_logined,
              duration: 3,
              placement: "bottomRight",
            })
          );

          setLoginError(data.message);
          localStorage.removeItem("waiting");

          setTimeout(() => {
            navigate("/dashboard", { replace: true });
          }, 100);
        } else {
          setLoginError("Password is incorrect");
          setTimeout(() => {
            setLoginError("Authenticate");
          }, 1000);

          setAuthenticating(false);
        }
      }
    );
  };

  useEffect(() => {
    if (localStorage.getItem("username") === null) {
      navigate("/", { replace: true });
    }
  }, []);

  return (
    <ProConfigProvider hashed={false}>
      <div
        style={{
          backgroundColor: token.colorBgContainer,
          paddingTop: "10%",
          textAlign: "center",
        }}
      >
        <LockOutlined style={{ fontSize: 80 }} className={"prefixIcon"} />
        <LoginForm
          title="Session Expired"
          subTitle="Please enter your password to re-login"
          submitter={{
            searchConfig: {
              submitText: loginError,
            },
          }}
          loading={Authenticating}
          contentStyle={{
            width: 350,
          }}
          onFinish={(values) => {
            authorize(values.password);
          }}
        >
          <Tabs
            centered
            activeKey={loginType}
            onChange={(activeKey) => setLoginType(activeKey as LoginType)}
          >
            <Tabs.TabPane
              key={"password"}
              tab={localStorage.getItem("username")}
            />
          </Tabs>
          {loginType === "password" && (
            <div style={{ marginBottom: 24 }}>
              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                ]}
              >
                <Input.Password
                  size="large"
                  placeholder="Password"
                  visibilityToggle={{
                    visible: passwordVisible,
                    onVisibleChange: setPasswordVisible,
                  }}
                />
              </Form.Item>
            </div>
          )}
        </LoginForm>
      </div>
    </ProConfigProvider>
  );
};
